import { FaMapMarkerAlt } from 'react-icons/fa';

import { isDefinedString, Text } from '@client/toolkit';

export interface AgreementSpaceAddressProps {
  name: string | undefined;
  address: string | undefined;
}

export function AgreementSpaceAddress({ name, address }: AgreementSpaceAddressProps) {
  return (
    <div className="overflow-hidden text-ellipsis">
      <Text as="div" isEmpty={!isDefinedString(name)}>
        <strong className="whitespace-nowrap font-medium">{name}</strong>
      </Text>
      <div className="flex items-center overflow-hidden">
        <FaMapMarkerAlt className="text-xs text-red-600 inline mr-1 -mt-1 -mb-1" />
        <Text
          as="div"
          className="text-xs font-normal text-secondary flex-1 whitespace-nowrap"
          isEmpty={!isDefinedString(address)}
        >
          {address}
        </Text>
      </div>
    </div>
  );
}
